import styled from "styled-components"

import padding from "@irati/ui/src/global/padding"

export default styled.div`
  padding: ${(props) => (props.addPadding ? padding.tiny : 0)};
`
